// import axios from "axios";
import axios from "axios";
import { baseURL } from "../../utils/URL";

const onCreateOragnization = async (postData:any, config:any) => {
  // const myHeaders = new Headers();
  // myHeaders.append("Authorization", config.headers.Authorization);

  // try {
  //   const requestOptions: RequestInit = {
  //     method: "POST",
  //     headers: myHeaders,
  //     body: postData,
  //     redirect: "follow",
  //   };

  //   var response = await fetch(`${baseURL}/organization`, requestOptions);

  //   var jsonresponse = response.json();

  //   return jsonresponse;
  // } catch (error: any) {
  //   if (error?.response?.data?.message === undefined) {
  //     throw error.message;
  //   } else {
  //     throw error?.response?.data?.message;
  //   }
  // }

  try {
    const response = await axios.post(`${baseURL}/organization`, postData, config);
    return response.data;
  } catch (error: any) {
    console.log(error?.response);
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }

}

  const onGetOrgusers = async ( config: any) => {
    try {
      const response = await axios.get(`${baseURL}/organization/user`, config);
      return response.data;
    } catch (error: any) {
      console.log(error?.response);
      if (error?.response?.data?.message === undefined) {
        throw error.message;
      } else {
        throw error?.response?.data?.message;
      }
    }
  };



  export{onCreateOragnization, onGetOrgusers}